import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ApiClient from "../helpers/ApiClient";

const ApiContext = createContext();

const PREVIEW_KEY = "cms_preview_site";

export default function ApiProvider({ children }) {
  const [searchParams] = useSearchParams();
  const siteFromUrl = searchParams.get("site") || null;

  const [site, setSite] = useState(
    () => siteFromUrl || sessionStorage.getItem(PREVIEW_KEY) || null
  );

  useEffect(() => {
    if (siteFromUrl) {
      setSite(siteFromUrl);
      sessionStorage.setItem(PREVIEW_KEY, siteFromUrl);
    }
  }, [siteFromUrl]);

  const api = useMemo(() => new ApiClient(site), [site]);

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi() {
  return useContext(ApiContext);
}
